var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeachingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.724 22H9.25A3.24 3.24 0 0 1 9 20.75v-5.5A3.25 3.25 0 0 1 12.25 12h8.5c.442 0 .864.088 1.249.249V5.25l-.005-.154A2.25 2.25 0 0 0 19.749 3H4.25l-.154.005A2.25 2.25 0 0 0 2 5.25v10.502l.005.154A2.25 2.25 0 0 0 4.148 18H4v.002h3.499V20.5H5.75l-.102.007A.75.75 0 0 0 5.724 22h1ZM10 15.25A2.25 2.25 0 0 1 12.25 13h8.5A2.25 2.25 0 0 1 23 15.25v5.5A2.25 2.25 0 0 1 20.75 23h-8.5A2.25 2.25 0 0 1 10 20.75v-5.5Zm4 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm3.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm2.5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.25 18a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-4.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-2 2c0 .414.336.75.75.75h5.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0-.75.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeachingActive);
export default __webpack_public_path__ + "static/media/ic-teaching-active.23d03ac2a130ac0f3da92b4e2715e0bd.svg";
export { ForwardRef as ReactComponent };